import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import cl from './Contacts.module.css';
import contact from '../../image/PHONE-3_1.large.medium_quality.jpg';
import { Link, animateScroll as scroll } from 'react-scroll';

const Contacts = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);
  const position = props.coordinates?.split(', ') || [41.9226605, 12.5102558];

  return (
    <section className={cl.contact}>
      <div className={cl.main}>
        <div className={cl.contacts}>
          <h1 className={cl.title}>Contatti</h1>
          <div className={cl.wrapper}>
            <MapContainer
              center={position}
              zoom={12}
              scrollWheelZoom={false}
              style={{ height: '200px', width: '220px', margin: '10px' }}>
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={position} />
            </MapContainer>
            <div>
              <p>{props.shopName}</p>
              <p>{props.address}</p>
              <p>
                Tel:{' '}
                <a href="tel:123-456-7890" className={cl.link}>
                  123-456-7890
                </a>
              </p>
              <p>
                Email:{' '}
                <a href={'mailto: support@' + props.domain} className={cl.link}>
                  support@{props.domain}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
